import { queryOptions } from '@tanstack/react-query'
import { fetchDefaultExchangeRates } from '../service/exchangeRateService'
import exchangeRateQueryKeys from './exchangeRateQueryKeys'
import { Currency } from '../../../types/currency/Currency'
import { DefaultExchangeRate } from '../types/exchangeRate'
import { createDate } from '../../../config/dayjsConfig'

export type IndexedDefaultExchangeRates = {
  [key: string]: DefaultExchangeRate // key format: "M/Y"
}

// Utility function to index rates
const indexDefaultExchangeRates = (rates: DefaultExchangeRate[]): IndexedDefaultExchangeRates => {
  return rates.reduce((acc, rate) => {
    const date = createDate(rate.year, rate.month)
    const indexKey = date
      ? `${rate.statementType}-${date.format('MM/YYYY')}`
      : `${rate.statementType}-${String(rate.month).padStart(2, '0')}/${rate.year}`
    acc[indexKey] = rate
    return acc
  }, {} as IndexedDefaultExchangeRates)
}

// Query options with select
export function defaultExchangeRateOptions(from?: Currency, to?: Currency) {
  return queryOptions({
    queryKey: exchangeRateQueryKeys.default(from, to),
    queryFn: fetchDefaultExchangeRates,
    enabled: !!from && !!to,
    select: (data: DefaultExchangeRate[]): IndexedDefaultExchangeRates => {
      return indexDefaultExchangeRates(data)
    }
  })
}
